export default __webpack_public_path__ + "static/media/IndigoTrace_Map.6cf705b1.svg";